(function(){
  if(window.__fpd){ window.__fpd(); return; }
  var D=document;
  if(!D.getElementById('fpd-es')){var st=D.createElement('style');st.id='fpd-es';st.textContent='.fpd .ebx .shopify-app-block,.fpd .ebx .es-popup-button{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important;pointer-events:auto!important;cursor:pointer;z-index:3}';D.head.appendChild(st);}
  function $(s,c){return (c||D).querySelector(s)}
  function $$(s,c){return [].slice.call((c||D).querySelectorAll(s))}

  /* --- botón de EasySell (u otra app de pago contra entrega) --- */
  var BTN='.es-popup-button,button,a[href],[role="button"],input[type="submit"]';
  var SKIP='[role="dialog"],[class*="modal" i],[class*="drawer" i]';
  function trigger(){
    var z=$('.fpd .ebx'), list=z?$$(BTN,z):[], i, b;
    for(i=0;i<list.length;i++){ b=list[i]; if(!b.closest(SKIP)) return b; }
    return $('.es-popup-button,[class*="easysell" i] button,[id*="easysell" i] button,button[class*="easysell" i]');
  }
  function arm(){
    var z=$('.fpd .ebx'), b=trigger();
    if(!z||!b||!z.contains(b)) return;
    var el=b.parentElement;
    while(el&&el!==z){
      el.style.setProperty('position','static','important');
      el.style.setProperty('transform','none','important');
      el.style.setProperty('overflow','visible','important');
      el=el.parentElement;
    }
    var s={position:'absolute',top:'0',left:'0',right:'0',bottom:'0',width:'100%',height:'100%','min-height':'0',margin:'0',padding:'0',opacity:'0','pointer-events':'auto',cursor:'pointer','z-index':'3'};
    for(var k in s) b.style.setProperty(k,s[k],'important');
    b.setAttribute('tabindex','0');
  }
  function toast(t){
    var e=$('.fpd .toast'); if(e) e.remove();
    e=D.createElement('div'); e.className='toast'; e.textContent=t;
    D.body.appendChild(e); setTimeout(function(){e.remove()},4500);
  }
  function buy(){
    var b=trigger();
    if(b){ b.click(); return; }
    if(window.Shopify&&window.Shopify.designMode){ toast('Agrega el bloque de EasySell en Apps (sección Hero) para abrir el formulario.'); return; }
    var f=$('form.fpdf'); if(f) f.submit();
  }
  D.addEventListener('click',function(e){
    var c=e.target.closest&&e.target.closest('[data-cta]');
    if(!c) return; e.preventDefault(); buy();
  });
  var mo=null;
  function watch(){
    var z=$('.fpd .ebx'); if(!z) return;
    arm();
    if(mo) mo.disconnect();
    if('MutationObserver' in window){
      var t; mo=new MutationObserver(function(){clearTimeout(t);t=setTimeout(arm,120)});
      mo.observe(z,{childList:true,subtree:true});
    }
    setTimeout(arm,800); setTimeout(arm,2500);
  }

  /* --- aparecer al hacer scroll --- */
  var io=null;
  function reveal(){
    var an=$$('.fpd .a:not(.in)');
    if(!('IntersectionObserver' in window)){ an.forEach(function(e){e.classList.add('in')}); return; }
    if(!io) io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.1});
    an.forEach(function(e){ if(!e.__o){e.__o=1;io.observe(e)} });
  }

  /* --- carrusel --- */
  function gallery(g){
    if(g.__g) return; g.__g=1;
    var trk=$('.trk',g), sl=$$('.sl',g), ths=$$('.th button',g), cnt=$('.cnt',g);
    if(!trk) return;
    function cur(){return Math.round(trk.scrollLeft/Math.max(1,trk.clientWidth))}
    function go(i){i=Math.max(0,Math.min(sl.length-1,i));trk.scrollTo({left:i*trk.clientWidth,behavior:'smooth'})}
    var t;
    trk.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){
      var i=cur();
      ths.forEach(function(b,k){if(k===i)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current')});
      if(cnt)cnt.textContent=(i+1)+'/'+sl.length;
    },40)},{passive:true});
    ths.forEach(function(b,k){b.addEventListener('click',function(){go(k)})});
    var p=$('.ar.p',g), n=$('.ar.n',g);
    if(p)p.addEventListener('click',function(){go(cur()-1)});
    if(n)n.addEventListener('click',function(){go(cur()+1)});
    trk.addEventListener('keydown',function(e){if(e.key==='ArrowRight')go(cur()+1);if(e.key==='ArrowLeft')go(cur()-1)});
  }

  /* --- variantes --- */
  function variants(){
    $$('.fpd input[name="fpd-v"]').forEach(function(r){
      if(r.__v) return; r.__v=1;
      r.addEventListener('change',function(){
        var f=r.closest('form'), id=f&&$('input[name="id"]',f); if(id) id.value=r.value;
        var box=r.closest('.fpd'), pe=$('.pr b',box), ce=$('.pr s',box), oe=$('.pr em',box), c=r.getAttribute('data-c'), o=r.getAttribute('data-o');
        if(pe) pe.textContent=r.getAttribute('data-p');
        if(ce){ce.textContent=c||'';ce.hidden=!c}
        if(oe){oe.textContent=o?('Ahorras '+o+'%'):'';oe.hidden=!o}
      });
    });
  }

  /* --- barra fija --- */
  function sticky(){
    var stk=$('.fpd .stk'), main=$('.fpd .eb'); if(!stk||!main||stk.__s||!('IntersectionObserver' in window)) return;
    stk.__s=1;
    var out=false, fin=false, fe=$('.fpd[data-fin] .cta');
    function upd(){var on=out&&!fin;stk.classList.toggle('on',on);stk.setAttribute('aria-hidden',on?'false':'true');var b=$('button',stk);if(b)b.tabIndex=on?0:-1}
    new IntersectionObserver(function(es){var e=es[0];out=!e.isIntersecting&&e.boundingClientRect.top<0;upd()}).observe(main);
    if(fe) new IntersectionObserver(function(es){fin=es[0].isIntersecting;upd()}).observe(fe);
  }

  function boot(){ $$('.fpd .gal').forEach(gallery); variants(); reveal(); watch(); sticky(); }
  window.__fpd=boot;
  if(D.readyState==='loading') D.addEventListener('DOMContentLoaded',boot); else boot();
  D.addEventListener('shopify:section:load',function(){setTimeout(boot,50)});
})();
